import '@aws-amplify/ui-react/styles.css';

export * from './Amplify';
export * from './ApolloClient';
export * from './HTTPClient';
export * from './types';

declare global {
	interface Window {
		Cypress?: any;
	}
}
